import { styled } from '@mui/material/styles';

const ExportButton = styled('div')`
    cursor: pointer;
    margin-bottom: 0.5em;
    margin-right: 1.5em;
`;

export default ExportButton;
